<div class="p-3">
  <div class="page-title d-flex justify-content-between align-items-center mb-3">
    <h3 class="m-0">Tenant Listing</h3>
    <p-button
      (click)="showDialogForCreate('right')"
      class="primary-btn"
      icon="pi pi-plus"
      label="Create Tenant"
      severity="secondary"
    ></p-button>
    <!-- <p-button type="button" label="Reset Filters" class="primary-btn p-button-secondary" (click)="resetFilters()"></p-button> -->
  </div>

  <!-- Filters -->
  <div class="filters">
    <div class="filters-container w-100 m-0">

    
      <!-- <div class="col-md-4 p-1">
        <label for="nameFilter">Name</label>
        <p-dropdown
          id="nameFilter"
          [options]="nameOptions"
          [(ngModel)]="filters.name"
          placeholder="Select Name"
          (onChange)="onFilterChange()"
        ></p-dropdown>
      </div>
      <div class="col-md-4 p-1">
        <label for="emailFilter">Email</label>
        <p-dropdown
          id="emailFilter"
          [options]="emailOptions"
          [(ngModel)]="filters.email"
          placeholder="Select Email"
          (onChange)="onFilterChange()"
        ></p-dropdown>
      </div> -->
      <!-- <div class="col-md-4 p-1">
        <label for="emailFilter">Phone</label>
        <p-dropdown
          id="phoneFilter"
          [options]="phoneOptions"
          [(ngModel)]="filters.phone"
          placeholder="Select Phone"
          (onChange)="onFilterChange()"
        ></p-dropdown>
      </div> -->
      <div class="p-1">
        <label for="search" class="dropdown-label">Search</label>
        <input
          id="searchField"
          type="text"
          class="form-control"
          placeholder="Search..."
          [(ngModel)]="filters.search"
          (input)="onFilterChange(); sanitizeInput($event)" 
          (keydown)="blockSpecialChars($event)"
          (paste)="blockSpecialCharsOnPaste($event)"
          (drop)="blockSpecialCharsOnDrop($event)" 
        />
      </div>
    </div>

  </div>

  <!-- Table -->
  <div class="tenants-listing p-4 mt-3 m-1">
    <p-table
      [value]="tenants"
      [lazy]="true"
      responsiveLayout="scroll"
      [paginator]="true"
      [rows]="itemsPerPage"
      [totalRecords]="totalRecords"
      (onLazyLoad)="fetchTenants($event)"
      [sortField]="sorting.field"
      [sortOrder]="sorting.order"
      [rowsPerPageOptions]="[10,20,50]" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
      <ng-template pTemplate="header">
        <tr>
          <th>#</th>
          <th pSortableColumn="name">Name <p-sortIcon field="name"></p-sortIcon></th>
          <th pSortableColumn="email">Email <p-sortIcon field="email"></p-sortIcon></th>
          <th pSortableColumn="phone">Phone <p-sortIcon field="phone"></p-sortIcon></th>
          <th>Notifications</th>
          <th>Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-tenant>
        <tr>
          <td>{{ userIndex(tenant) }}</td>
          <td>{{ tenant.first_name }} {{ tenant.last_name }}</td>
          <td>{{ tenant.email }}</td>
          <td>{{ tenant.phone }}</td>
          <td>
            <p-inputSwitch
              [ngModel]="tenant.isActive !== false"
              [disabled]="togglingStatus[tenant._id]"
              (onChange)="toggleTenantStatus(tenant, $event)"
              pTooltip="When off, this tenant receives no SMS or email"
              tooltipPosition="top"
            ></p-inputSwitch>
          </td>
          <td>
            <div class="d-flex align-items-center gap-2">
            <p-button
              pButton
              [icon]="sendingCredentials[tenant._id] ? 'pi pi-spinner pi-spin' : 'pi pi-send'"
              [disabled]="sendingCredentials[tenant._id]"
              class="icon-secondary-btn"
              pTooltip="Send Credentials"
              tooltipPosition="top"
              (click)="sendCredentials(tenant)"
            ></p-button>
            <p-button
              pButton
              icon="pi pi-pencil"
              class="icon-secondary-btn"
              (click)="showDialogForEdit('right', tenant)"
            ></p-button>
            <p-button
              pButton
              icon="pi pi-trash"
              class="icon-primary-btn"
              (click)="confirmDelete(tenant._id)"
            ></p-button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog
  *ngIf="visible"
  [header]="selectedTenant ? 'Update Tenant' : 'Create Tenant'"
  [modal]="true"
  [(visible)]="visible"
  [position]="position"
  [style]="{ width: '35%' }"
  draggable="false"
>
  <app-create-tenants
    *ngIf="visible"
    [tenantData]="selectedTenant"
    (closeDialog)="onDialogClose()"
  ></app-create-tenants>
</p-dialog>
<div class="dlt-confirmation-dialog">
  <p-confirmDialog></p-confirmDialog>
</div>
<p-toast></p-toast>
